import { render, staticRenderFns } from "./DasherAge.vue?vue&type=template&id=051d3cfc&scoped=true"
import script from "./DasherAge.vue?vue&type=script&lang=js"
export * from "./DasherAge.vue?vue&type=script&lang=js"
import style0 from "./DasherAge.vue?vue&type=style&index=0&id=051d3cfc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "051d3cfc",
  null
  
)

export default component.exports